'use client';
import React, { useState } from 'react';
import dynamic from 'next/dynamic';

const OIBarChart = dynamic(() => import('./OIBarChart'), { ssr: false });

interface Props {
  underlying: string;
}

export default function OIChartSection({ underlying }: Props) {
  const [view, setView] = useState<'oi' | 'oichange' | 'volume'>('oi');

  return (
    <div className="card-elevated p-4 h-full">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-semibold text-foreground">Open Interest Distribution</h3>
        <div className="flex items-center gap-1 bg-muted rounded-lg p-0.5">
          {(['oi', 'oichange', 'volume'] as const).map((v) => (
            <button
              key={`oiview-${v}`}
              onClick={() => setView(v)}
              className={`px-2.5 py-1 text-2xs font-semibold rounded-md transition-all ${
                view === v ? 'bg-card text-foreground' : 'text-muted-foreground hover:text-foreground'
              }`}
            >
              {v === 'oi' ? 'OI' : v === 'oichange' ? 'OI Change' : 'Volume'}
            </button>
          ))}
        </div>
      </div>
      <div className="flex items-center gap-4 mb-3 text-2xs">
        <span className="flex items-center gap-1.5"><span className="w-3 h-3 rounded-sm bg-negative inline-block" />CE (Call)</span>
        <span className="flex items-center gap-1.5"><span className="w-3 h-3 rounded-sm bg-positive inline-block" />PE (Put)</span>
      </div>
      <OIBarChart underlying={underlying} view={view} />
    </div>
  );
}